import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const SecureRoute = ({ children, ...rest }) => {
    const { user, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }

    if (user) {
        if (user.email === 'md.hazratali4510@gmail.com') {
            return children;
        }
    }
    return <Navigate to="/" state={{ from: location }} />;
};

export default SecureRoute;